import React from 'react';
import FramingTimelineContents from './FramingTimelineContents';
import { FramingTimelineProvider } from './FramingTimelineContext';

export type FramingTimelineProps = {};

const FramingTimeline = () => (
  <FramingTimelineProvider>
    <FramingTimelineContents />
  </FramingTimelineProvider>
);

export default FramingTimeline;
